<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">Leeann deWitt for encouragement and honesty.</p><br/>
<p style="text-align: center;">Gillian Ward, author of <em>Tragedy and Heroism at Kopuawhara</em> (2019).</p><br/>
<p style="text-align: center;">Friends and family and especially Peter. Thank you all.</p>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0c9eb27d